document.addEventListener('DOMContentLoaded', function() {
  function handleAccordionClick(event) {
    const target = event.target;

    // Check if the clicked element is an accordion button inside #quickshop
    if (target.closest('#quickshop') && target.classList.contains('accordion__button')) {
      const button = target;
      const panel = button.parentElement.nextElementSibling;
      const faqIcons = button.querySelector('.icon');
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded attribute
      button.setAttribute('aria-expanded', String(!isExpanded));

      // Toggle panel visibility
      panel.style.display = isExpanded ? 'none' : 'block';

      // Toggle icon class if necessary
      if (faqIcons) {
        faqIcons.classList.toggle('icon--active', !isExpanded);
      }
    }
  }

  document.addEventListener('click', handleAccordionClick);
});
